import { render, staticRenderFns } from "./TemplateListing.vue?vue&type=template&id=48dbf1cf&scoped=true&"
import script from "./TemplateListing.vue?vue&type=script&lang=js&"
export * from "./TemplateListing.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListing.vue?vue&type=style&index=0&id=48dbf1cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dbf1cf",
  null
  
)

export default component.exports